const setCurrencyFormat = (value) => {
  return value
    ? value.toLocaleString(navigator.language, { minimumFractionDigits: 0 })
    : 0;
};

export default setCurrencyFormat;
